import React from "react";
import PropTypes from "prop-types";
import Input from "antd/lib/input";
import { getDefaultName } from "../../pages/alert/Alert";
import map from "lodash";
import { Alert as AlertType } from "@/components/proptypes";
import FavoritesControl from "@/components/favorites-control/FavoritesControl";
import { AlertTagsControl } from "@/components/tags-control/TagsControl";
import getTags from "@/services/getTags";
import { useTheme } from "@/components/ThemeProvider";

import "./Title.less";

function getAlertTags() {
  return getTags("api/alerts/tags").then(tags => map(tags, t => t.name)) || [];
}

export default function Title({ 
  alert, 
  editMode, 
  name, 
  children, 
  tagsExtra,
  onChange,  
  canEdit,
  setAlertTags,
}) {
  const defaultName = getDefaultName(alert);
  const { isDarkMode } = useTheme();

  return (
    <div className={`alert-header ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className={`title-with-tags ${isDarkMode ? 'dark-mode' : ''}`}>
        <div className={`page-title ${isDarkMode ? 'dark-mode' : ''}`}>
          <div className={`d-flex align-items-center ${isDarkMode ? 'dark-mode' : ''}`}>
            {alert.id && <FavoritesControl item={alert} />}
            <h3>
              {editMode && alert.query ? (
                <Input
                  className="f-inherit"
                  placeholder={defaultName}
                  value={name}
                  aria-label="Alert title"
                  onChange={e => onChange(e.target.value)}
                />
              ) : (
                name || defaultName
              )}
            </h3>
          </div>
        </div>
        <div className={`alert-tags ${isDarkMode ? 'dark-mode' : ''}`}>
          <AlertTagsControl
            tags={alert.tags}
            isArchived={alert.is_archived}
            canEdit={canEdit}
            getAvailableTags={getAlertTags}
            onEdit={setAlertTags}
            tagsExtra={tagsExtra}
          />
        </div>
      </div>
      <div className={`header-actions ${isDarkMode ? 'dark-mode' : ''}`}>
        {children}
      </div>
    </div>
  );
}

Title.propTypes = {
  alert: AlertType.isRequired,
  editMode: PropTypes.bool,
  name: PropTypes.string,
  children: PropTypes.node,
  tagsExtra: PropTypes.node,
  onChange: PropTypes.func,
  canEdit: PropTypes.bool,
  setAlertTags: PropTypes.func,
};

Title.defaultProps = {
  editMode: false,
  name: null,
  children: null,
  tagsExtra: null,
  onChange: () => {},
  canEdit: false,
  setAlertTags: () => {},
};
